import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { editListingStatusAction } from 'store/state/uploadBulletin/actions';
import { createSelector } from 'reselect';
import { routeSelector } from 'store/state/selectors/router';
import {
  unitPageBulletinSelector,
  unitPageCommercialBulletinSelector,
  userProfileSelector,
} from 'store/state/domainData/selectors';
import { Route } from 'config/routes';
import UpdateListingStatusPopup from './UpdateListingStatusPopup';
import { updateListingStatusModalSelector } from 'store/state/app/selectors';
import { cancelSubscriptionThenEditListingStatus, setUpdateListingStatusModal, cancelUserPromotionPlan } from 'store/state/app/actions';
import { allPoisByIdsHeapSelector } from 'store/state/selectors/poisHeap';
import { UpdateListingStatusPopupProps } from 'components/update-listing-status-popup/types';
import { userCurrentPromotionPlanDomainDataSelector } from 'store/state/app/private-user-monetization/selectors';


const poiSelector = createSelector([
  routeSelector,
  unitPageBulletinSelector,
  unitPageCommercialBulletinSelector,
], (route, bulletin, commercialBulletin) => {
  let poi = null;

  switch (route.name) {
    case Route.UnitPage:
      poi = bulletin;
      break;
    case Route.UnitPageCommercial:
      poi = commercialBulletin;
      break;
  }
  return poi;
});

const promotionPlanForOpenUpdateStatusModalSelector = createSelector(
  [ updateListingStatusModalSelector, userCurrentPromotionPlanDomainDataSelector ],
  (modal, promotionData) => {
    if (!modal || !modal.id || !promotionData) return null;
    const bulletinPlan = promotionData.bulletinPromotionPlans.find(plan => plan.bulletinId === modal.id);
    return bulletinPlan || promotionData.accountPromotionPlan;
  }
);

const mapStateToProps = (state: State) => ({
  poi: poiSelector(state),
  updateListingStatusModalState: updateListingStatusModalSelector(state),
  poisHeap: allPoisByIdsHeapSelector(state),
  currentUser: userProfileSelector(state),
  promotionPlan: promotionPlanForOpenUpdateStatusModalSelector(state),
});

const mapDispatchToProps = {
  editListingStatus: editListingStatusAction,
  setModalOpenStatus: setUpdateListingStatusModal,
  onCancelPromotionPlan: cancelUserPromotionPlan,
  cancelSubscriptionThenEditListingStatus,
};

const UnconnectedUpdateListingStatusPopup: React.FC<UpdateListingStatusPopupProps> = (props) => {
  if (!props.poi || !props.status) return null;
  return <UpdateListingStatusPopup {...props}/>;
};

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, ownProps) => {
  const { poi, poisHeap, updateListingStatusModalState, promotionPlan } = stateProps;
  const listing = poi || poisHeap[updateListingStatusModalState && updateListingStatusModalState.id];

  return ({
    poi: listing,
    status: updateListingStatusModalState && updateListingStatusModalState.status,
    source: updateListingStatusModalState && updateListingStatusModalState.source,
    currentUser: stateProps.currentUser,
    promotionPlan,
    ...dispatchProps,
    ...ownProps,
  });
})(UnconnectedUpdateListingStatusPopup);

